import { Pipe, PipeTransform } from '@angular/core';

interface TrackByFunctionCache {
  [propertyName: string]: <T>(index: number, item: T) => any;
}

const cache: TrackByFunctionCache = Object.create(null);

@Pipe({
  name: 'trackByKey',
})
export class TrackByKey implements PipeTransform {
  public transform(propertyName: string): (index: number, item: any) => any {
    // track by memory reference if nothing is provided
    if (propertyName === null) {
      return trackByMemoryReference;
    }
    // Ensure cached function exists.
    if (!cache[propertyName]) {
      cache[propertyName] = function trackByProperty<T>(index: number, item: T): any {
        return item[propertyName];
      };
    }

    return cache[propertyName];
  }
}

function trackByMemoryReference(index: number, item: any): any {
  return item;
}
